// GitInfoPage.js
import React from 'react';
import ReusableGitInfoPage from '../../b2b-common/pages/ReusableGitInfoPage';
import 'react-json-pretty/themes/monikai.css';
import { fetchGitIndicatorsData } from '../../../services/b2b-indicators-apiService';

const GitInfoPage = () => {
    return (
        <ReusableGitInfoPage bannerMessage="Indicators Menu: Show Git commit info." fetchMethod={fetchGitIndicatorsData} />
    );
};

export default GitInfoPage;
